// ATTENTION: This is an auto-generated types file from scripts/update_js_lib.py and should not be modified directly!
export var AnalyticsEvent;
(function (AnalyticsEvent) {
    AnalyticsEvent["AccountSelected"] = "Account Selected";
    AnalyticsEvent["AddressValidated"] = "Address Validated";
    AnalyticsEvent["AutocompleteSuggestionSelected"] = "Autocomplete Suggestion Selected";
    AnalyticsEvent["AvailableStoreClicked"] = "Available Store Clicked";
    AnalyticsEvent["AvailableStoreViewed"] = "Available Store Viewed";
    AnalyticsEvent["BulkProductAddedToCart"] = "Bulk Product Added To Cart";
    AnalyticsEvent["BulkProductAddedToList"] = "Bulk Product Added To List";
    AnalyticsEvent["BusinessCreated"] = "Business Created";
    AnalyticsEvent["BusinessUpdated"] = "Business Updated";
    AnalyticsEvent["CardAdded"] = "Card Added";
    AnalyticsEvent["CardReentered"] = "Card Reentered";
    AnalyticsEvent["CardSelected"] = "Card Selected";
    AnalyticsEvent["CartViewed"] = "Cart Viewed";
    AnalyticsEvent["CheckoutDetailsClicked"] = "Checkout Details Clicked";
    AnalyticsEvent["CheckoutDetailsFailed"] = "Checkout Details Failed";
    AnalyticsEvent["CheckoutDetailsUpdated"] = "Checkout Details Updated";
    AnalyticsEvent["CheckoutDetailsViewed"] = "Checkout Details Viewed";
    AnalyticsEvent["CheckoutProcessCompleted"] = "Checkout Process Completed";
    AnalyticsEvent["CheckoutProcessFailed"] = "Checkout Process Failed";
    AnalyticsEvent["CheckoutProcessStarted"] = "Checkout Process Started";
    AnalyticsEvent["ElementClicked"] = "Element Clicked";
    AnalyticsEvent["ElementViewed"] = "Element Viewed";
    AnalyticsEvent["EligibilityChecked"] = "Eligibility Checked";
    AnalyticsEvent["FilterUtilityClicked"] = "Filter Utility Clicked";
    AnalyticsEvent["FilterUtilityViewed"] = "Filter Utility Viewed";
    AnalyticsEvent["FirstOrderPlaced"] = "First Order Placed";
    AnalyticsEvent["FirstPurchased"] = "First Purchased";
    AnalyticsEvent["FormSubmitted"] = "Form Submitted";
    AnalyticsEvent["InviteAccepted"] = "Invite Accepted";
    AnalyticsEvent["InviteRejected"] = "Invite Rejected";
    AnalyticsEvent["LiveChatConversationEnded"] = "Live Chat Conversation Ended";
    AnalyticsEvent["LiveChatConversationStarted"] = "Live Chat Conversation Started";
    AnalyticsEvent["LoginCompleted"] = "Login Completed";
    AnalyticsEvent["LoginError"] = "Login Error";
    AnalyticsEvent["MFAToggled"] = "MFA Toggled";
    AnalyticsEvent["OrderCancelled"] = "Order Cancelled";
    AnalyticsEvent["OrderPromoSubmitted"] = "Order Promo Submitted";
    AnalyticsEvent["OrderRated"] = "Order Rated";
    AnalyticsEvent["OutOfStockSubstitutePreferenceSaved"] = "Out Of Stock Substitute Preference Saved";
    AnalyticsEvent["OutOfStockSubstitutePreferenceSelected"] = "Out Of Stock Substitute Preference Selected";
    AnalyticsEvent["OutOfStockSubstitutePreferenceViewed"] = "Out Of Stock Substitute Preference Viewed";
    AnalyticsEvent["PasswordResetStepCompleted"] = "Password Reset Step Completed";
    AnalyticsEvent["PaymentError"] = "Payment Error";
    AnalyticsEvent["PaymentMethodAdded"] = "Payment Method Added";
    AnalyticsEvent["PlanCancelled"] = "Plan Cancelled";
    AnalyticsEvent["PlanReactivated"] = "Plan Reactivated";
    AnalyticsEvent["PlanStarted"] = "Plan Started";
    AnalyticsEvent["PlanTypeClicked"] = "Plan Type Clicked";
    AnalyticsEvent["PlanTypeViewed"] = "Plan Type Viewed";
    AnalyticsEvent["PreferencesSaved"] = "Preferences Saved";
    AnalyticsEvent["PreferredShopperListUpdated"] = "Preferred Shopper List Updated";
    AnalyticsEvent["ProductAddedToCart"] = "Product Added To Cart";
    AnalyticsEvent["ProductAddedToList"] = "Product Added To List";
    AnalyticsEvent["ProductAddedToOrder"] = "Product Added To Order";
    AnalyticsEvent["ProductClicked"] = "Product Clicked";
    AnalyticsEvent["ProductRemovedFromCart"] = "Product Removed From Cart";
    AnalyticsEvent["ProductRemovedFromList"] = "Product Removed From List";
    AnalyticsEvent["ProductRemovedFromOrder"] = "Product Removed From Order";
    AnalyticsEvent["ProductRemoved"] = "Product Removed";
    AnalyticsEvent["ProductSwapped"] = "Product Swapped";
    AnalyticsEvent["ProductViewed"] = "Product Viewed";
    AnalyticsEvent["ProductsSearched"] = "Products Searched";
    AnalyticsEvent["PromoCardClicked"] = "Promo Card Clicked";
    AnalyticsEvent["PromoCardViewed"] = "Promo Card Viewed";
    AnalyticsEvent["ReceiptExported"] = "Receipt Exported";
    AnalyticsEvent["RegistrationCompleted"] = "Registration Completed";
    AnalyticsEvent["SearchSuggestionsViewed"] = "Search Suggestions Viewed";
    AnalyticsEvent["SegmentConsentPreferenceUpdated"] = "Segment Consent Preference Updated";
    AnalyticsEvent["ShopperTipUpdated"] = "Shopper Tip Updated";
    AnalyticsEvent["ShopperTipped"] = "Shopper Tipped";
    AnalyticsEvent["SpecialRequestAdded"] = "Special Request Added";
    AnalyticsEvent["SponsoredContentLoaded"] = "Sponsored Content Loaded";
    AnalyticsEvent["StoreResultsViewed"] = "Store Results Viewed";
    AnalyticsEvent["UserGroupInviteRevoked"] = "User Group Invite Revoked";
    AnalyticsEvent["UserInvited"] = "User Invited";
    AnalyticsEvent["UserRemoved"] = "User Removed";
})(AnalyticsEvent || (AnalyticsEvent = {}));
